query InvoiceSigningSearchHints(
  $invoiceSigningSearchRequest: SearchRequestInput!
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $isSearchAllData: Boolean
  $filterMultiStatusTypes: [Int]
  $filterSupplierId: UUID
) {
  invoiceSigningSearchHints(
    searchRequest: $invoiceSigningSearchRequest
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    isSearchAllData: $isSearchAllData
    filterMultiStatusTypes: $filterMultiStatusTypes
    filterSupplierId: $filterSupplierId
  ) {
    nodes {
      id
      caption
      resultsCount
    }
  }
}
